export default function nullArray(length: number) {
    return Array.from(Array(length)).map(() => null); //_item
}